const textDefaults = {
	EN: {
		title: 'Contractor Admin Registration',
		securityNote: 'For security reasons, please do not provide a generic or shared email address.',
		emailLabel: 'Email',
		emailPlaceholder: 'Enter email address',
		addButtonText: 'Add Email',
		description: `
		<p>Through this registration form, you can register a Contractor Admin for your company.</p>
		<p>Once the Contractor Admin has been submitted through this form, they will receive an invitation mail to activate their account.</p>
		`,
	},
	FR: {
		title: "Enregistrement d'Administrateur Contractant",
		securityNote: 'Pour des raisons de sécurité, veuillez ne pas fournir une adresse e-mail générique ou partagée.',
		emailLabel: 'E-mail',
		emailPlaceholder: "Entrez l'adresse e-mail",
		addButtonText: 'Ajouter un e-mail',
		description: `
		<p>Grâce à ce formulaire d'inscription, vous pouvez enregistrer un Administrateur Contractant pour votre entreprise.</p>
		<p>Une fois l'Administrateur Contractant soumis via ce formulaire, il recevra un e-mail d'invitation pour activer son compte.</p>
		`,
	},
	NL: {
		title: 'Aannemer Admin Registratie',
		securityNote: 'Om veiligheidsredenen dient u geen algemeen of gedeeld e-mailadres op te geven.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Voer e-mailadres in',
		addButtonText: 'E-mail toevoegen',
		description: `
		<p>Via dit registratieformulier kunt u een Aannemer Admin voor uw bedrijf registreren.</p>
		<p>Zodra de Aannemer Admin via dit formulier is ingediend, ontvangt hij of zij een uitnodigingsmail om zijn of haar account te activeren.</p>
		`,
	},
	DE: {
		title: 'Auftragnehmer-Admin-Registrierung',
		securityNote: 'Aus Sicherheitsgründen geben Sie bitte keine generische oder geteilte E-Mail-Adresse an.',
		emailLabel: 'E-Mail',
		emailPlaceholder: 'E-Mail-Adresse eingeben',
		addButtonText: 'E-Mail hinzufügen',
		description: `
		<p>Über dieses Registrierungsformular können Sie einen Auftragnehmer-Admin für Ihr Unternehmen registrieren.</p>
		<p>Sobald der Auftragnehmer-Admin über dieses Formular eingereicht wurde, erhält er oder sie eine Einladungs-E-Mail zur Aktivierung seines oder ihres Kontos.</p>
		`,
	},
	PL: {
		title: 'Rejestracja Administratora Wykonawcy',
		securityNote: 'Ze względów bezpieczeństwa, proszę nie podawać ogólnego adresu e-mail.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Wprowadź adres e-mail',
		addButtonText: 'Dodaj e-mail',
		description: `
		<p>Za pomocą tego formularza rejestracyjnego możesz zarejestrować Administratora Wykonawcy dla swojej firmy.</p>
		<p>Po przesłaniu Administratora Wykonawcy przez ten formularz, otrzyma on lub ona e-mail z zaproszeniem do aktywacji swojego konta.</p>
		`,
	},
	BG: {
		title: 'Регистрация на администратор на изпълнител',
		securityNote: 'От съображения за сигурност, моля не предоставяйте общ имейл адрес.',
		emailLabel: 'Имейл',
		emailPlaceholder: 'Въведете имейл адрес',
		addButtonText: 'Добави имейл',
		description: `
		<p>Чрез този регистрационен формуляр можете да регистрирате администратор на изпълнител за вашата компания.</p>
		<p>След като администраторът на изпълнител бъде изпратен чрез този формуляр, той ще получи имейл с покана за активиране на акаунта си.</p>
		`,
	},
	CS: {
		title: 'Registrace administrátora dodavatele',
		securityNote: 'Z bezpečnostních důvodů prosím neuveďte obecnou e-mailovou adresu.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Zadejte e-mailovou adresu',
		addButtonText: 'Přidat e-mail',
		description: `
		<p>Pomocí tohoto registračního formuláře můžete zaregistrovat administrátora dodavatele pro vaši společnost.</p>
		<p>Jakmile bude administrátor dodavatele odeslán prostřednictvím tohoto formuláře, obdrží pozvánku e-mailem k aktivaci svého účtu.</p>
		`,
	},
	DA: {
		title: 'Registrering af entreprenør-administrator',
		securityNote: 'Af sikkerhedsmæssige årsager skal du ikke angive en generisk e-mailadresse.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Indtast e-mailadresse',
		addButtonText: 'Tilføj e-mail',
		description: `
		<p>Gennem denne registreringsformular kan du registrere en entreprenør-administrator for dit firma.</p>
		<p>Når entreprenør-administratoren er indsendt gennem denne formular, vil han eller hun modtage en invitationsmail for at aktivere sin konto.</p>
		`,
	},
	ES: {
		title: 'Registro de administrador de contratista',
		securityNote: 'Por razones de seguridad, no proporcione una dirección de correo electrónico genérica.',
		emailLabel: 'Correo electrónico',
		emailPlaceholder: 'Ingrese la dirección de correo electrónico',
		addButtonText: 'Agregar correo electrónico',
		description: `
		<p>A través de este formulario de registro, puede registrar un administrador de contratista para su empresa.</p>
		<p>Una vez que el administrador de contratista haya sido enviado a través de este formulario, recibirá un correo de invitación para activar su cuenta.</p>
		`,
	},
	FI: {
		title: 'Urakoitsijan järjestelmänvalvojan rekisteröinti',
		securityNote: 'Turvallisuussyistä älä anna yleistä sähköpostiosoitetta.',
		emailLabel: 'Sähköposti',
		emailPlaceholder: 'Anna sähköpostiosoite',
		addButtonText: 'Lisää sähköposti',
		description: `
		<p>Tämän rekisteröintilomakkeen avulla voit rekisteröidä urakoitsijan järjestelmänvalvojan yrityksellesi.</p>
		<p>Kun urakoitsijan järjestelmänvalvoja on lähetetty tämän lomakkeen kautta, hän saa kutsuviestin tilinsä aktivointia varten.</p>
		`,
	},
	HR: {
		title: 'Registracija administratora izvođača',
		securityNote: 'Iz sigurnosnih razloga, molimo ne navedite generičku adresu e-pošte.',
		emailLabel: 'E-pošta',
		emailPlaceholder: 'Unesite adresu e-pošte',
		addButtonText: 'Dodaj e-poštu',
		description: `
		<p>Putem ovog registracijskog obrasca možete registrirati administratora izvođača za vašu tvrtku.</p>
		<p>Nakon što administrator izvođača bude poslan putem ovog obrasca, primit će pozivnicu e-poštom za aktivaciju svog računa.</p>
		`,
	},
	HU: {
		title: 'Vállalkozó adminisztrátor regisztráció',
		securityNote: 'Biztonsági okokból kérjük, ne adjon meg általános e-mail címet.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Adja meg az e-mail címet',
		addButtonText: 'E-mail hozzáadása',
		description: `
		<p>Ezen regisztrációs űrlap segítségével egy vállalkozó adminisztrátort regisztrálhat a vállalkozásához.</p>
		<p>Miután a vállalkozó adminisztrátor elküldésre került ezen űrlapon keresztül, meghívó e-mailt kap fiókja aktiválásához.</p>
		`,
	},
	IT: {
		title: 'Registrazione amministratore appaltatore',
		securityNote: 'Per motivi di sicurezza, si prega di non fornire un indirizzo e-mail generico.',
		emailLabel: 'E-mail',
		emailPlaceholder: "Inserisci l'indirizzo e-mail",
		addButtonText: 'Aggiungi e-mail',
		description: `
		<p>Attraverso questo modulo di registrazione, puoi registrare un amministratore appaltatore per la tua azienda.</p>
		<p>Una volta che l'amministratore appaltatore è stato inviato tramite questo modulo, riceverà un'e-mail di invito per attivare il suo account.</p>
		`,
	},
	NO: {
		title: 'Registrering av entreprenør-administrator',
		securityNote: 'Av sikkerhetshensyn, vennligst ikke oppgi en generisk e-postadresse.',
		emailLabel: 'E-post',
		emailPlaceholder: 'Skriv inn e-postadresse',
		addButtonText: 'Legg til e-post',
		description: `
		<p>Gjennom dette registreringsskjemaet kan du registrere en entreprenør-administrator for ditt firma.</p>
		<p>Når entreprenør-administratoren er sendt inn gjennom dette skjemaet, vil han eller hun motta en invitasjonsmail for å aktivere kontoen sin.</p>
		`,
	},
	PT: {
		title: 'Registo de administrador de contratante',
		securityNote: 'Por razões de segurança, não forneça um endereço de e-mail genérico.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Introduza o endereço de e-mail',
		addButtonText: 'Adicionar e-mail',
		description: `
		<p>Através deste formulário de registo, pode registar um administrador de contratante para a sua empresa.</p>
		<p>Assim que o administrador de contratante for submetido através deste formulário, receberá um e-mail de convite para ativar a sua conta.</p>
		`,
	},
	RO: {
		title: 'Înregistrare administrator antreprenor',
		securityNote: 'Din motive de securitate, vă rugăm să nu furnizați o adresă de e-mail generică.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Introduceți adresa de e-mail',
		addButtonText: 'Adăugați e-mail',
		description: `
		<p>Prin acest formular de înregistrare, puteți înregistra un administrator antreprenor pentru compania dvs.</p>
		<p>După ce administratorul antreprenor a fost trimis prin acest formular, va primi un e-mail de invitație pentru a-și activa contul.</p>
		`,
	},
	RU: {
		title: 'Регистрация администратора подрядчика',
		securityNote: 'По соображениям безопасности, пожалуйста, не указывайте общий адрес электронной почты.',
		emailLabel: 'Электронная почта',
		emailPlaceholder: 'Введите адрес электронной почты',
		addButtonText: 'Добавить электронную почту',
		description: `
		<p>Через эту регистрационную форму вы можете зарегистрировать администратора подрядчика для вашей компании.</p>
		<p>После того, как администратор подрядчика будет отправлен через эту форму, он получит пригласительное письмо для активации своей учетной записи.</p>
		`,
	},
	SK: {
		title: 'Registrácia administrátora zhotoviteľa',
		securityNote: 'Z bezpečnostných dôvodov prosím neuveďte všeobecnú e-mailovú adresu.',
		emailLabel: 'E-mail',
		emailPlaceholder: 'Zadajte e-mailovú adresu',
		addButtonText: 'Pridať e-mail',
		description: `
		<p>Prostredníctvom tohto registračného formulára môžete zaregistrovať administrátora zhotoviteľa pre vašu spoločnosť.</p>
		<p>Po odoslaní administrátora zhotoviteľa prostredníctvom tohto formulára dostane pozvánku e-mailom na aktiváciu svojho účtu.</p>
		`,
	},
	SI: {
		title: 'Registracija administratorja izvajalca',
		securityNote: 'Iz varnostnih razlogov prosimo ne navedite generičnega e-poštnega naslova.',
		emailLabel: 'E-pošta',
		emailPlaceholder: 'Vnesite e-poštni naslov',
		addButtonText: 'Dodaj e-pošto',
		description: `
		<p>Skozi ta registracijski obrazec lahko registrirate administratorja izvajalca za vaše podjetje.</p>
		<p>Ko bo administrator izvajalca poslan preko tega obrazca, bo prejel povabilo po e-pošti za aktivacijo svojega računa.</p>
		`,
	},
	SV: {
		title: 'Registrering av entreprenör-administratör',
		securityNote: 'Av säkerhetsskäl, ange inte en generisk e-postadress.',
		emailLabel: 'E-post',
		emailPlaceholder: 'Ange e-postadress',
		addButtonText: 'Lägg till e-post',
		description: `
		<p>Genom detta registreringsformulär kan du registrera en entreprenör-administratör för ditt företag.</p>
		<p>När entreprenör-administratören har skickats in via detta formulär kommer han eller hon att få ett inbjudningsmejl för att aktivera sitt konto.</p>
		`,
	},
	TR: {
		title: 'Müteahhit yönetici kaydı',
		securityNote: 'Güvenlik nedenleriyle lütfen genel bir e-posta adresi sağlamayın.',
		emailLabel: 'E-posta',
		emailPlaceholder: 'E-posta adresini girin',
		addButtonText: 'E-posta ekle',
		description: `
		<p>Bu kayıt formu aracılığıyla şirketiniz için bir müteahhit yönetici kaydedebilirsiniz.</p>
		<p>Müteahhit yönetici bu form aracılığıyla gönderildikten sonra, hesabını etkinleştirmek için bir davet e-postası alacaktır.</p>
		`,
	},
	UK: {
		title: 'Реєстрація адміністратора підрядника',
		securityNote: 'З міркувань безпеки, будь ласка, не вказуйте загальну адресу електронної пошти.',
		emailLabel: 'Електронна пошта',
		emailPlaceholder: 'Введіть адресу електронної пошти',
		addButtonText: 'Додати електронну пошту',
		description: `
		<p>Через цю реєстраційну форму ви можете зареєструвати адміністратора підрядника для вашої компанії.</p>
		<p>Після того, як адміністратор підрядника буде відправлений через цю форму, він отримає запрошення електронною поштою для активації свого облікового запису.</p>
		`,
	},
};

export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
